// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge_1XB27","danger":"Badge_danger_3sbTf Badge_badge_1XB27","warning":"Badge_warning_HhAe4 Badge_badge_1XB27"};